<template>
  <div class="intersets-div container-fluid">
    <div class="container-fluid">
      <div class="row" id="">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header row">
              <div class="col-md-6 pl-0">
                <h4 class="card-title card-title-irish-date">
                  Choose your interests
                </h4>
              </div>
              <div class="col-md-6 text-right">
                <button
                  class="btn btn-bumblebee btn-mid btn-mid-primary-outline"
                  @click="clickAddInterest"
                >
                  Add Interest
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-overlay
        class="overlay-show-center"
        :show="overlay_show"
        rounded="sm"
        variant="mid-primary"
        opacity="0.5"
        blur="2px"
      >
        <b-row>
          <b-col md="3" cols="6" v-for="item in interests" :key="item.id">
            <SingleInterest
              :title="item.name"
              :id="item.id"
              :img_src="item.media.path"
              client_name="MID"
            />
          </b-col>
        </b-row>
      </b-overlay>
    </div>
    <!-- delete modal -->
    <b-modal id="deleteInterestModal" centered modal-class="modal-irish-date">
      <div class="d-block mb-4">
        <input
          id="interest_id"
          name="interest_id"
          type="hidden"
          v-model="interest_id"
        />
        <p class="confirmMessageModalP message-modal-mid my-4">
          Are you sure to delete this item?
        </p>
      </div>
      <template class="justify-content-center mt-5" #modal-footer>
        <b-row class="justify-content-center w-100">
          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              variant="mid-danger"
              class="w-100 btn-bumblebee btn-mid btn-mid-submit"
              @click="clickConfirmDeleteInterest"
            >
              Yes
            </b-button>
          </b-col>

          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              variant="mid-secondary-outline"
              class="w-100 btn-bumblebee btn-mid btn-mid-submit"
              @click="closeModalDelete"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <!-- end delete modal-->
    <!-- add modal -->
    <b-modal
      id="addInterestModal"
      centered
      modal-class="modal-irish-date"
      hide-footer
    >
      <template #modal-title> Interest Info </template>
      <div class="d-block mb-4">
        <input
          id="interest_id"
          name="interest_id"
          type="hidden"
          v-model="interest_id"
        />
      </div>
      <b-form @submit.prevent="onSubmit">
        <b-row class="mt-3">
          <b-col md="12">
            <b-form-group
              label="Title"
              label-for="title"
              :title="title"
              label-class="form-label-mid"
            >
              <b-form-input
                id="title"
                v-model="title"
                :title="title"
                class="form-control-mid"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Image"
              label-for="cover_image"
              :cover_image="cover_image"
              class="imgFromGroup h-100"
              label-class="form-label-mid"
            >
              <p class="error_validation_message_p" v-if="invalid_cover_img">
                Please select image
              </p>
              <input
                type="file"
                class="file-upload inputFileHidden d-none"
                name="cover_image"
                id="cover_image"
                accept="image/*"
                @change="previewImage"
              />

              <div
                class="previewImageDiv previewImageMIDDiv"
                @click="addFile('cover_image')"
                v-bind:style="{ 'background-image': 'url(' + preview + ')' }"
                style="height: 220px"
              >
                <p v-show="preview == null" class="uploadFileP text-center">
                  Click here to upload your image
                </p>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <template class="justify-content-center mt-5" #modal-footer> -->
        <b-row class="justify-content-center w-100 mt-5">
          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="submit"
              variant="mid-primary"
              class="w-100 btn-bumblebee btn-mid btn-mid-submit"
              v-if="!is_loading"
            >
              Save
            </b-button>
            <b-button
              type="submit"
              disabled
              variant="mid-primary"
              class="w-100 btn-bumblebee btn-mid btn-mid-submit"
              v-else
            >
              <b-spinner
                small
                label="Small Spinner"
                variant="light"
              ></b-spinner>
              Loading
            </b-button>
          </b-col>

          <b-col lg="4" md="6" class="text-center">
            <b-button
              type="button"
              variant="mid-danger-outline"
              class="w-100 btn-bumblebee btn-mid btn-mid-submit"
              @click="closeModalInfo"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
        <!-- </template> -->
      </b-form>
    </b-modal>
    <!-- end add modal -->
  </div>
</template>

<script>
import $, { event } from "jquery";
import axios from "axios";
import SingleInterest from "./SingleInterest.vue";
export default {
  name: "MIDInterests",
  components: { SingleInterest },
  data() {
    return {
      // interests: [
      //   {
      //     id: 1,
      //     title: "Test",
      //     img_src: require("@/assets/images/my-irish-date/interests_images/interest01.png"),
      //   },
      //   {
      //     id: 2,
      //     title: "Camp",
      //     img_src: require("@/assets/images/my-irish-date/interests_images/interest02.png"),
      //   },
      //   {
      //     id: 3,
      //     title: "Music",
      //     img_src: require("@/assets/images/my-irish-date/interests_images/interest03.png"),
      //   },
      //   {
      //     id: 4,
      //     title: "Reading",
      //     img_src: require("@/assets/images/my-irish-date/interests_images/interest04.png"),
      //   },
      //   {
      //     id: 5,
      //     title: "Coding",
      //     img_src: require("@/assets/images/my-irish-date/interests_images/interest05.png"),
      //   },
      //   {
      //     id: 6,
      //     title: "Shopping",
      //     img_src: require("@/assets/images/my-irish-date/interests_images/interest06.png"),
      //   },
      //   {
      //     id: 7,
      //     title: "Yoga",
      //     img_src: require("@/assets/images/my-irish-date/interests_images/interest07.png"),
      //   },
      //   {
      //     id: 8,
      //     title: "Art",
      //     img_src: require("@/assets/images/my-irish-date/interests_images/interest08.png"),
      //   },
      // ],
      interests: [],
      interest_id: null,
      title: null,
      cover_image: null,
      preview: null,
      cover_image_id: null,
      is_loading: false,
      overlay_show: false,
      invalid_cover_img: false,
      client_name:"MID"
    };
  },
  mounted() {
    this.overlay_show = true;
    this.getInterestsList();
  },
  methods: {
    getInterestsList() {
      axios
        .get("social/admin/interests", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data.data);
          this.interests = response.data.data;
          this.overlay_show = false;
        });
    },
    clickDeleteInterest(id) {
      console.log("delete interest ", id);
      this.interest_id = id;

      this.$root.$emit("bv::show::modal", "deleteInterestModal");
    },
    clickConfirmDeleteInterest() {
      console.log("confirm delete interest " + this.interest_id);
      // this.$bvModal.hide("deleteInterestModal");

      axios
        .delete("social/admin/interests/" + this.interest_id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          this.$bvModal.hide("deleteInterestModal");
          // this.$parent.getEventsList();
          this.$fire({
            // title: "Title",
            text: "Interst is deleted successfully.",
            type: "success",
            timer: 5000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.getInterestsList();
        })
        .catch((error) => {
          console.log(error.response.data.error);
          console.log(error.request);
          console.log(error.message);
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 5000,
          }).then((r) => {
            // console.log(r.value);
          });
          // this.loginErrorMessage = error.response.data.error;
          // this.showLoginErrorMessage = true;
        });
    },
    closeModalDelete() {
      this.$bvModal.hide("deleteInterestModal");
    },
    clickAddInterest() {
      console.log("click add interest");
      this.interest_id = null;
      this.title = null;
      this.preview = null;
      this.cover_image = null;
      this.cover_image_id = null;
      this.$root.$emit("bv::show::modal", "addInterestModal");
    },
    clickEditInterest(id) {
      console.log("click edit interest ", id);
      this.overlay_show = true;
      this.interest_id = id;
      // get interest data
      axios
        .get("social/admin/interests/" + id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          this.title = response.data.name;
          this.preview = response.data.media.path;
          this.cover_image_id = response.data.media.id;
          this.$root.$emit("bv::show::modal", "addInterestModal");
          this.overlay_show = false;
        });
    },
    onSubmit(event) {
      console.log("confirm save info");
      console.log(this.interest_id);
      console.log(this.title);
      console.log(this.cover_image);

      // check in add if cover img is null

      //  this.$bvModal.hide("addInterestModal");
      // this.$fire({
      //   // title: "Title",
      //   text: "Interest is saved successfully.",
      //   type: "success",
      //   timer: 5000,
      // }).then((r) => {
      //   // console.log(r.value);
      // });
      if (this.interest_id == null) {
        console.log("submit add interest");
        if (this.interest_id == null && this.cover_image == null) {
          this.invalid_cover_img = true;
        } else {
          this.invalid_cover_img = false;
          this.is_loading = true;
          this.sendSaveMedia("add");
        }
      } else {
        console.log("submit edit interest");
        this.is_loading = true;
        if (this.cover_image == null) {
          this.sendEditInterest();
        } else {
          this.sendSaveMedia("edit");
        }
      }
    },
    closeModalInfo() {
      this.$bvModal.hide("addInterestModal");
    },
    sendSaveMedia(action) {
      console.log("in save media");
      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("selectedfile", this.cover_image);

      axios
        .post("filesmodule/upload", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          //this.is_loading = false;
          this.cover_image_id = response.data.id;
          if (action === "add") {
            this.sendAddInterest();
          } else {
            this.sendEditInterest();
          }
        })
        .catch((error) => {
          console.log(error.response.data.error);
          console.log(error.request);
          console.log(error.message);
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            timer: 5000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    sendAddInterest() {
      console.log("in send add interest");
      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("name", this.title);
      formData.append("media_id", this.cover_image_id);

      axios
        .post("social/admin/interests", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Interest is created successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          this.$bvModal.hide("addInterestModal");
          this.getInterestsList();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },

    sendEditInterest() {
      console.log("in send edit interest " + this.interest_id);
      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("name", this.title);
      formData.append("_method", "put");
      formData.append("media_id", this.cover_image_id);

      axios
        .post("social/admin/interests/" + this.interest_id, formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Interest is updated successfully",
            type: "success",
            timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          this.$bvModal.hide("addInterestModal");
          this.getInterestsList();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },

    previewImage: function (e) {
      console.log(this.cover_image);
      var input = e.target;
      if (input.files) {
        var reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.cover_image = e.target.files[0];
        console.log(this.cover_image);
      }
    },
    addFile(id) {
      console.log("click file " + id);
      $("#" + id).click();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_irish_date/interests_describe/Interests.vue